import React, { useState } from 'react'
import Creatable from '../Creatable'

const CityExceptions = props => {
    const [inputVal, setInputVal] = useState("")
    const [error, setError] = useState({ isErr: false, msg: null })
    return (
        <div className='rule__values'>
            <Creatable
                isDisabled={props.disabled}
                inputValue={inputVal}
                setInputValue={setInputVal}
                label="Cities"
                id="exp_cities"
                placeholder="Add Cities"
                defaults={props.exp_cities}
                handleChange={!props.disabled ? props.handleChange : () => { }}
                value={props.exp_cities}
                error={error}
                err={null}
                valuesAllowed={5}
                setError={setError}
            />
        </div>
    )
}

export default CityExceptions
